import { render, staticRenderFns } from "./PartijBeknopt.vue?vue&type=template&id=3294dc2a&"
import script from "./PartijBeknopt.vue?vue&type=script&lang=js&"
export * from "./PartijBeknopt.vue?vue&type=script&lang=js&"
import style0 from "./PartijBeknopt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports